import { render, staticRenderFns } from "./CourseEnrollIndexPage.vue?vue&type=template&id=b377f4fa&scoped=true"
import script from "./CourseEnrollIndexPage.vue?vue&type=script&lang=js"
export * from "./CourseEnrollIndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b377f4fa",
  null
  
)

export default component.exports